<div *ngIf="isLoading" class="spinner-container">
  <div class="spinner"></div>
   
</div>
<div *ngIf="!isLoading">
  <ng-content></ng-content>
</div>
